
import React from 'react';
import {PaymentsContainer2} from "../PaymentsDashboard/common";
import { loadWlfAdmins } from "./actions";
import {Action, Spinner} from "../../funcs/utils";
import ReactTable from "react-table";
import { OptionMenu } from "../../../lib/prm/option-menu";
import { Text } from "../../../lib/prm/text";
import { Name } from "../../../lib/prm/name";
import { FlowRender } from "../../../lib/flow-render";
import { is_uuid } from "../../../lib/uuid";
import { sprintf } from "sprintf-js";
import {NewAdminDialog} from "./new-admin-dialog";
import { ROOT } from "../../../lib/fake";
import {deep_copy} from "../../../lib/js-utils";
import { string_cmp } from "../../../lib/js-utils";
import {ErrorDialog} from "./error-dialog";

const WLF_MENU = new OptionMenu(new Name("WLF_MENU"));
const NAME = new Text(new Name("NAME"));
const EMAIL = new Text(new Name("EMAIL"));
const PASSWORD = new Text(new Name("PASSWORD"));

const ALL_PRMS = new FlowRender(0, [
  WLF_MENU,
  NAME,
  EMAIL,
  PASSWORD,
]);

const mk_wlf_menu = wlfs => {
  let index = 0;
  wlfs.forEach(wlf => {
    if (!is_uuid(wlf.id)) {
      WLF_MENU.menu.push(
        new Name(wlf.id, sprintf("%s (%s)", wlf.name, wlf.id), index));
      index++;
    }
  })
};

class SA_WLF_Admins extends React.Component {

  constructor(props) {
    super(props);
    const new_state = {
      users: [],
      page_token: null,
      loading: false,
      show_dialog: false,
      creating_admin: false,
      highlight_rects: [],
      error: false,
      error_msg: "",
    };
    if (WLF_MENU.menu.length === 0) {
      mk_wlf_menu(props.wlfs);
    }
    ALL_PRMS.init(new_state, {}, this);
    this.state = new_state;
    this.dialog_ref = React.createRef();
  }

  componentDidMount = () => {
    this.doLoad();
  }

  doLoad = () => {
    this.setState({ loading: true })
    loadWlfAdmins(this.props.token)
      .then(result => {
        this.setState( {
          loading: false,
          users: result.items,
          page_token: result.page_token,
        });
      });
  }

  onNewAdmin = user => {
    const users = deep_copy(this.state.users);
    users.push(user);
    users.sort((a, b) => string_cmp(a.username, b.username));
    this.setState({ users });
  }

  lookupWlfName = item => {
    const wlf = this.props.wlfs.filter(wlf => wlf.id === item.wlf_id);
    if (wlf.length === 1) {
      return wlf[0].name;
    }
    return item.wlf;
  }

  renderAction = row => {
    return (
      <div align={"center"}>
        <span>Action</span>
      </div>
    )
  }

  maybeDumpTable = () => {
    if (this.state.loading) {
      return null;
    }
    return (
      <div>
        <ReactTable
          data={this.state.users}
          pageSize={this.state.users.length}
          showPagination={false}
          className={"-striped -highlight"}
          columns={[
            {
              Header: "WLF Name",
              id: "wlf",
              accessor: this.lookupWlfName,
            },
            {
              Header: "WLF ID",
              id: "wlf_id",
              accessor: item => item.wlf_id,
            },
            {
              Header: "Name",
              id: "name",
              accessor: item => item.name,
            },
            {
              Header: "Email",
              id: "email",
              accessor: item => item.email,
            },
            {
              Header: "Action",
              id: "action",
              Cell: this.renderAction,
            }
          ]}
        />
      </div>
    )
  }
  render = () => {
    const loading = this.state.loading
      ? (
        <div align={"center"} style={{ fontSize: "2rem"}}>
          <Spinner/>
        </div>
      )
      : null;

    const button_div_style = {
      display: "flex",
      marginTop: "2rem",
      justifyContent: "center",
    }
    const on_click = () => {
      const new_state = deep_copy(this.state);
      PASSWORD.setValue(new_state, ROOT.random.password(20));
      new_state.show_dialog = true;
      this.setState(new_state);
    }

    const prms = { WLF_MENU, NAME, EMAIL, PASSWORD };
    const dialog = this.state.show_dialog
      ? (
        <NewAdminDialog
          component={this}
          prms={prms}/>)
      : null;
    const error_dialog = this.state.error
      ? (<ErrorDialog component={this}/>)
      : null;

    return (
      <div className='img-col'>
        <PaymentsContainer2
          client={this.props.client}
          title={"WLF Admins"}>
          { loading }
          { this.maybeDumpTable() }
          <div style={button_div_style}>
            <Action onClick={on_click}>
              Add WLF Admin
            </Action>
          </div>
        </PaymentsContainer2>
        { dialog }
        { error_dialog }
      </div>
    );
  }
}

export { SA_WLF_Admins };
